export default "__VITE_ASSET__B_jIHs6b__"